// extracted by mini-css-extract-plugin
export var actionButton = "_cy-0";
export var fileInput = "_cy-2";
export var paperclip = "_cy-1";